import React, { useEffect, useState } from "react";

import { Button } from "Components/atoms/Button";
import { DatePickerWithInputMobile } from "Components/molecules/DatePickerWithInput/Mobile";
import { useCalendarContext } from "shared/contexts/CalendarContext";

import {
  FieldSearchContentMobile,
  FieldSearchHeaderMobile,
  FieldSearchMobile,
} from "../styles";
// @ts-ignore
import { ReactComponent as CalendarGoingSvg } from "assets/svgs/calendar-going.svg";
import { ReactComponent as CalendarBackSvg } from "assets/svgs/calendar-back.svg";
import { FaArrowLeft } from "react-icons/fa";
import { size } from "polished";
import { useGeneralContext } from "shared/contexts/GeneralContext";
import { useSearchContext } from "shared/contexts/SearchContext";
import { orderDatesAsc } from "shared/utils/dates";
import { DataSearchMobile } from "./types";

export const DataSearchOriginMobile: React.FC<DataSearchMobile> = ({
  type,
}) => {
  const {
    daysInMonth,
    selectionMode,
    selectedOriginDates,
    selectedDestinationDates,
    setSelectedOriginDates,
    setSelectedDestinationDates,
    setShowOriginCalendarPickerMobile,
    setShowDestinationCalendarPickerMobile,
  } = useCalendarContext();
  const [isVisible, setIsVisible] = useState(false);
  const { setIsHeaderVisible, isHeaderVisible } = useGeneralContext();
  const { setDepartureDates, setReturnDates, searchState } = useSearchContext();

  const handleSetDepartureDates = (dates: string[]) => {
    const newDates = orderDatesAsc(dates);
    setSelectedOriginDates(newDates);
    setDepartureDates(newDates);
  };

  const handleSetDestinationDates = (dates: string[]) => {
    const newDates = orderDatesAsc(dates);
    setSelectedDestinationDates(newDates);
    setReturnDates(newDates);
  };

  useEffect(() => {
    setSelectedOriginDates(searchState?.departureDates ?? []);
    setDepartureDates(searchState?.departureDates ?? []);

    setSelectedDestinationDates(searchState?.returnDates ?? []);
    setReturnDates(searchState?.returnDates ?? []);
  }, [searchState.departureDates, searchState.returnDates]);

  useEffect(() => {
    setIsHeaderVisible(!isVisible);
  }, [isVisible, setIsHeaderVisible]);

  const handleIsVisible = () => {
    type === "origin"
      ? setShowOriginCalendarPickerMobile(false)
      : setShowDestinationCalendarPickerMobile(false);
  };

  return (
    <FieldSearchMobile isVisible={isVisible}>
      <DatePickerWithInputMobile
        title={
          selectionMode === "multi"
            ? `Selecione até 4 datas de ${type === "origin" ? "ida" : "volta"}`
            : ""
        }
        placeholder={
          selectionMode === "multi"
            ? `Datas de ${type === "origin" ? "Ida" : "Volta"}`
            : searchState.tripType === "oneWay"
              ? "Só Ida"
              : "Ida e Volta"
        }
        maxSelectableDates={4}
        daysInMonth={daysInMonth}
        selectedDates={
          type === "origin"
            ? selectedOriginDates || []
            : selectedDestinationDates || []
        }
        onDatesChange={
          type === "origin"
            ? handleSetDepartureDates
            : handleSetDestinationDates
        }
        type={type}
        onConfirmAction={handleIsVisible}
        icon={
          type === "origin" ? (
            <CalendarGoingSvg width={10} height={10} />
          ) : (
            <CalendarBackSvg width={10} height={10} />
          )
        }
        isVisible={true}
        //  isDisabled={isDisabled}
        onClick={() => setIsVisible(true)}
      />
    </FieldSearchMobile>
  );
};
